import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import BranchAuthDetails from "./BranchAuthDetails";
import { handleGetRequest } from "../../services/GetTemplate";
import { handlePostRequest } from "../../services/PostTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { GetBranchAuthFurtherDetailsAction } from "../../redux/actions/branchAction";

function AddEditBranchAuthDetails({ authMatrixHeadId }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [roleOptions, setroleOptions] = useState([]);
    const [userLevelOptions, setuserLevelOptions] = useState([]);
    const [authMatrixDetailId, setauthMatrixDetailId] = useState("");
    const [editFlag, seteditFlag] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovRole").then((res) => {
            setroleOptions(res?.data);
        });
    }, []); // eslint-disable-line

    useEffect(() => {
        handleGetRequest("zbizgateway/lov/lovUserLevel/").then((res) => {
            setuserLevelOptions(res?.data);
        });
    }, []);

    const authMatrixHeadId__Store = useSelector((state) => state.branchSlice?.authBranchDetailsForm?.authMatrixHeadId);
    console.log("Auth matrix details==", authMatrixHeadId__Store);

    console.log("authMatrixHeadId__Store ::", authMatrixHeadId__Store);
    console.log("authMatrixHeadId ::", authMatrixHeadId);

    const fillAuthMatrixDetailsForm = (data) => {
        const userLevelId = { code: data?.lkpUserAuthLevel?.code, description: data?.lkpUserAuthLevel?.description, id: data?.lkpUserAuthLevel?.userAuthLevelId.toString(), longText: null, shortText: null };
        const roleId = { code: data?.tblUser?.userCode, description: data?.tblUser?.userName, id: data?.tblUser?.roleId.toString(), longText: null, shortText: null };
        formik.setFieldValue("srNo", data?.srNo);
        formik.setFieldValue("roleId", roleId);
        formik.setFieldValue("userLevelId", userLevelId);
        setauthMatrixDetailId(data?.authMatrixDetailId);
        seteditFlag(true);
    };

    const formik = useFormik({
        initialValues: {
            roleId: "",
            userLevelId: "",
            isSequential: "N",
            srNo: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.roleId) {
                errors.roleId = "This field is required.";
            }
            if (!data.userLevelId) {
                errors.userLevelId = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["roleId"] = parseInt(data?.roleId?.id);
            data["userLevelId"] = parseInt(data?.userLevelId?.id);

            if (editFlag === true) {
                data["authMatrixDetailId"] = authMatrixDetailId;
                data["roleId"] = parseInt(data?.roleId);
                data["userLevelId"] = parseInt(data?.userLevelId);
                data["srNo"] = data?.srNo.toString();
                delete data["isSequential"];
                delete data["toAmount"];
                await handlePutRequest(data, "zbizgateway/nonFin/saveBranchAuthMatrixDetail");
                await dispatch(GetBranchAuthFurtherDetailsAction("zbizgateway/nonFin/getAuthMatrix/" + authMatrixHeadId__Store));
            } else {
                console.log(data);
                let headId = "";
                if (authMatrixHeadId === null || authMatrixHeadId === undefined || authMatrixHeadId === "") {
                    headId = authMatrixHeadId__Store; // Incase if we are adding new record then we need to pass authMatrixHeadId from store when selecting from authMatrixDatatable
                } else headId = authMatrixHeadId;
                data["authMatrixHeadId"] = headId;
                await handlePostRequest(data, "zbizgateway/nonFin/saveBranchAuthMatrixDetail");
                // await dispatch(GetBranchAuthFurtherDetailsAction("zbiz/nonFin/getAuthMatrix/" + headId));
            }
            formik.resetForm();
            seteditFlag(false);
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Branch Authorization Details</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="roleId" className={classNames({ "p-error": isFormFieldValid("roleId") }, "Label__Text")}>
                                Role<span className="Label__Required">*</span>
                            </label>
                            <Dropdown id="roleId" placeholder="Enter Role" options={roleOptions} optionLabel="description" name="roleId" value={formik.values.roleId} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("roleId") }, "Dropdown__Round")} />
                            {getFormErrorMessage("roleId")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="userLevelId" className={classNames({ "p-error": isFormFieldValid("userLevelId") }, "Label__Text")}>
                                User Level<span className="Label__Required">*</span>
                            </label>
                            <Dropdown
                                id="userLevelId"
                                placeholder="Enter User Level"
                                options={userLevelOptions}
                                optionLabel="description"
                                name="userLevelId"
                                value={formik.values.userLevelId}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("userLevelId") }, "Dropdown__Round")}
                            />
                            {getFormErrorMessage("userLevelId")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <label htmlFor="srNo" className={classNames({ "p-error": isFormFieldValid("srNo") }, "Label__Text")}>
                                Sr No.<span className="Label__Required">*</span>
                            </label>
                            <InputText id="srNo" placeholder="Enter Serial No." name="srNo" value={formik.values.srNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("srNo") }, "Input__Round")} />

                            {getFormErrorMessage("srNo")}
                        </div>
                    </div>
                </div>
                <div className="Down__Btn">
                    <Button iconPos="right" disabled={authMatrixHeadId === undefined || authMatrixHeadId === null || authMatrixHeadId__Store === undefined || authMatrixHeadId__Store === null ? true : loading} label={editFlag ? "Edit" : "Add"} className="Btn__Dark" />
                </div>
            </form>
            <BranchAuthDetails fillAuthMatrixDetailsForm={fillAuthMatrixDetailsForm} />
        </div>
    );
}

export default AddEditBranchAuthDetails;
